import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompletionComponent } from 'src/app/completion/completion.component';
import { DocumentsComponent } from './features/documents/documents.component';
import { HRDocumentsComponent } from './features/documents/hr-documents/hr-documents.component';
import { BgvConsentComponent } from './features/bgv-consent/bgv-consent.component';
import { ReportsComponent } from './features/reports/reports.component';
import { CandidatereportsComponent } from './features/candidatereports/candidatereports.component';
const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
    { path: 'emp-data', loadChildren: () => import('./features/emp-data/emp-data.module').then(m => m.EmpDataModule), data: { title: 'Pre-Boarding - Employee Data' } },


    { path: 'epf-declaration', loadChildren: () => import('./features/epf-declaration/epf-declaration.module').then(m => m.EpfDeclarationModule),
    data: {
    title: 'Pre-Boarding - EPF Declaration',
    } 
    },
    { path: 'nominee-declaration', loadChildren: () => import('./features/nominee-declaration/nominee-declaration.module').then(m => m.NomineeDeclarationModule), data: { title: 'Pre-Boarding - Nominee Declaration' } },
    { path: 'police-verfication', loadChildren: () => import('./features/police-verification/police-verification.module').then(m => m.PoliceVerificationModule), data: { title: 'Pre-Boarding - Police Verification' } },
    {
        path: 'documents', component:DocumentsComponent,
    data: {
    title: 'Pre-Boarding - Documents',
        }
    },
    {
        path: 'hr-documents',component:HRDocumentsComponent,
    },
    { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule), data: { title: 'Pre-Boarding - Candidates' } },
    { path: 'complete', component: CompletionComponent },
    { path: 'HR-docs', component: HRDocumentsComponent},
    // { path: '**', redirectTo: 'dashboard' }
    { path: 'reports', component: ReportsComponent },
    { path: 'candidatesreports', component: CandidatereportsComponent },
    { path: 'bgv', loadChildren: () => import('./features/background-verification/bgv.module').then(m => m.BackgroundVerificationModule), data: { title: 'Pre-Boarding - BGV' } },
    {path: 'bgv-consent', component: BgvConsentComponent},
];
@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'top'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
